import React, { useMemo } from "react";
import { EventDetail, MarketEventI } from "src/types/eventDetail";
import { findMarketLimit, formatAmount } from "src/utils/functions";
import { useAppSelector } from "src/redux/redux-hooks";
import MarketTableRow from "./market-table-row";

// ------------------------------------------------------------
type Props = {
  sMarket: MarketEventI;
  event: EventDetail;
  marketExposureList: any[];
  onBetLockClick?: () => void;
  onUserBookClick?: (marketId: string, marketName: string) => void;
};
// ------------------------------------------------------------

const MarketTable: React.FC<Props> = ({ sMarket, event, marketExposureList, onBetLockClick, onUserBookClick }) => {
  const { userData } = useAppSelector((state) => state.user);

  const marketLimit = useMemo(() => {
    const marketLimit = findMarketLimit({
      market_limits: sMarket?.market_limits,
      currency_id: userData?.currency_id,
    });

    return marketLimit;
  }, [sMarket?.market_limits, userData?.currency_id]);

  const marketExposure = useMemo(() => {
    const marketExposure = marketExposureList?.find((exposure) => exposure.market_id === sMarket.market_id);
    return marketExposure;
  }, [marketExposureList, sMarket.market_id]);


  const min = marketLimit?.min ? formatAmount({ amt: marketLimit.min.toString() }).value : null;
  const max = marketLimit?.max ? formatAmount({ amt: marketLimit.max.toString() }).value : null;

  return (
    <div className="market-4">
      <div className="bet-table">
        <div className="bet-table-header">
          <div data-toggle="collapse" data-target="#market0" aria-expanded="true" className="nation-name">
            <span title={sMarket?.market_name}> {sMarket?.market_name} </span>
          </div>
          <div className="float-right">
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                onBetLockClick?.();
              }}
              className="btn btn-back"
            >
              Bet Lock
            </a>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                onUserBookClick?.(sMarket.market_id, sMarket.market_name);
              }}
              className="btn btn-back"
            >
              User Book
            </a>
          </div>
        </div>
        <div id="market0" data-title="OPEN" className="bet-table-body collapse show">
          <div className="bet-table-row bet-table-row-top">
            <div className="text-right nation-name">
              <span className="max-bet">
                {min && <span title={`Min : ${min}`}>Min: {min}</span>}{" "}
                {max && <span title={`Max : ${max}`}>Max: {max}</span>}
              </span>
            </div>
            <div className="back bl-title d-none-mobile">Back</div>
            <div className="lay bl-title d-none-mobile">Lay</div>
          </div>
          {Array.isArray(sMarket?.runners) &&
            sMarket.runners.map((runner, index) => {
              return (
                <MarketTableRow
                  runner={runner}
                  exposuresByApi={marketExposure}
                  event={event}
                  key={index}
                  market={sMarket}
                  maxAmount={marketLimit?.max}
                />
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default MarketTable;
